// material-ui
import { Theme } from '@mui/material/styles';

// ==============================|| OVERRIDES - CARD ||============================== //

export default function Card(theme: Theme) {
  return {
    MuiCard: {
      styleOverrides: {
        root: {
          position: 'relative',
          overflow: 'hidden',
          borderColor: theme.vars.palette.grey[200],
          backgroundColor: theme.vars.palette.background.paper,
          boxShadow: '0 14px 38px rgba(1, 0, 1, 0.06)',
          '&.MuiCard-root.MuiPaper-outlined': {
            borderColor: theme.vars.palette.grey[200]
          },
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: 3,
            backgroundColor: theme.vars.palette.primary.main
          }
        }
      }
    }
  };
}
